import { useQuery } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { useStore } from '../../../store';

export const getBucketStateQuery = () => {
  const { customerId } = useStore(state => state.user);
  return useQuery(
    'getBucketStateQuery',
    async () => {
      const res = await httpService.get(`${BASE_URL}/api/v1/user/${customerId}/bucket/emergency`);
      return res.data;
    },
    {
      cacheTime: 0,
      staleTime: 0,
      refetchOnWindowFocus: false,
    },
  );
};
